module.exports = __webpack_public_path__ + "static/media/primer.5149878d.tex";